<ng-container *ngIf="membershipData && membershipData?.length > 0">
  <ng-container *ngIf="!isCarousel">
    <div class="single-card">
      <ng-container
        *ngTemplateOutlet="
          cardTemplate;
          context: { $implicit: membershipData[0] }
        "
      >
      </ng-container>
    </div>
  </ng-container>

  <div *ngIf="isCarousel" class="membership-carousel-wrapper">
    <swiper-container slides-per-view="auto" space-between="12">
      <swiper-slide *ngFor="let item of membershipData">
        <ng-container
          *ngTemplateOutlet="cardTemplate; context: { $implicit: item }"
        >
        </ng-container>
      </swiper-slide>
    </swiper-container>
  </div>
</ng-container>
<ng-template #cardTemplate let-item>
  <div
    class="membership-banner w100 border-r10 ion-padding"
    [ngClass]="{
      'premium-card': (item?.tierType || item?.tierName) === 'PREMIUM',
      'lite-card': (item?.tierType || item?.tierName) !== 'PREMIUM'
    }"
  >
    <div class="d-flex membership-banner-inner">
      <ng-container *ngIf="cardType === 'offerDiscountCard'">
        <div class="membership-text">
          <div class="badge d-flex ion-align-items-center">
            <custom-icon
              class="icon-img"
              iconName="CROWN_ICON"
              [width]="17"
              [height]="13"
              colorClass="crown-icon"
            ></custom-icon>
            <span class="fs-2 font600">
              {{
                "shared.components.membership_card.membership_benefit"
                  | translate
              }}
            </span>
          </div>

          <p class="fs-3 font500 ion-no-margin mart10" *ngIf="item?.offerTitle">
            {{ item.offerTitle }}
          </p>

          <p class="fs-3 font500 ion-no-margin mart5" *ngIf="item.validity">
            {{ "shared.components.membership_card.validity" | translate }}:
            {{ item.validity }}
          </p>
        </div>

        <div
          class="membership-logo-wrap d-flex ion-align-items-start"
          *ngIf="item?.tierIcon || item?.tierLogo"
        >
          <img [src]="item.tierIcon || item.tierLogo" class="membership-premium-logo" />
        </div>
      </ng-container>

      <ng-container *ngIf="cardType === 'appliedDiscountCard'">
        <div class="membership-text">
          <div class="badge d-flex ion-align-items-center">
            <custom-icon
              class="icon-img"
              iconName="CROWN_ICON"
              [width]="17"
              [height]="13"
              colorClass="crown-icon"
            ></custom-icon>
            <span class="fs-2 font600">
              {{
                "shared.components.membership_card.membership_benefit_auto_applied"
                  | translate
              }}
            </span>
          </div>
        </div>

        <div
          class="membership-logo-wrap d-flex ion-align-items-start"
          *ngIf="item?.tierIcon || item?.tierLogo"
        >
          <img [src]="item.tierIcon || item.tierLogo" class="membership-premium-logo" />
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>
